import React from 'react'
import Navbar from '../components/navbar/navbar'
import Footer from '../components/footer/footer'
function Unijobs() {
  return (
    <>
    <Navbar />
    <div>
      <h1 id ='roboto' className='margintt red center marginb'>!!This services is under development!!</h1>
     
    </div>
    <Footer />
    </>
  )
}

export default Unijobs
